import React from 'react';
import Stack from '@mui/material/Stack';
import TwIndicator from '../TwIndicator/TwIndicator';
import { TimelineDottedLine } from './TwTimelineStepStyles';
import { GridContainer, GridItem, ThreeRowItem } from './TwTimelineStepStyles';

export interface TwTimelineStepProps {
  /**
   * step number in timeline
   */
  stepNumber: number;

  /**
   * is first step in timeline
   */
  firstStep?: boolean;

  /**
   * is last step in timeline
   */
  lastStep?: boolean;
  children: React.ReactNode;
}

const TwTimelineStep: React.FC<TwTimelineStepProps> = ({
  stepNumber,
  lastStep,
  children,
  firstStep
}): JSX.Element => {
  return (
    <Stack
      direction="column"
      spacing={1}
      justifyContent="flex-start"
      alignItems="flex-start"
      sx={{ width: '100%' }}
    >
      <GridContainer sx={{ width: '100%' }}>
        <GridItem>{!firstStep && <TimelineDottedLine style={{ height: '9px' }} />}</GridItem>

        <ThreeRowItem>{children}</ThreeRowItem>
        <TwIndicator
          content={`${stepNumber}`}
          variant={lastStep ? 'square' : 'circle'}
          color="#9CA3AF"
        />
        <GridItem>{!lastStep && <TimelineDottedLine />}</GridItem>
      </GridContainer>
    </Stack>
  );
};

export default TwTimelineStep;
